import httpService from "app/services/httpService";
import config from "../../../src/config.json";

const { apiUrl } = config;

const addService = async (values) => {
  try {
    const url = `${apiUrl}/servicemaster `;
    const { data } = await httpService.post(url, values);
    return data;
  } catch (error) {
    throw error;
  }
};

const getServiceForUpdate = async (id) => {
  try {
    const { data } = await httpService.get(
      `${apiUrl}/servicemaster/service/${id}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

const editService = async (req) => {
  try {
    const url = `${apiUrl}/servicemaster/update-service`;
    const { data } = await httpService.post(url, req);
    return data;
  } catch (error) {
    throw error;
  }
};

const getService = async (queryString) => {
  try {
    const url = `${apiUrl}/servicemaster/allservicelist${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const addDmrService = async (value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/commission/dmrcommission`,
      value
    );
    console.log(data);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getCommById = async (id, query) => {
  try {
    const url = `${apiUrl}/commission/dmrcommission/${id}${
      query ? `?searchText=${query}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getUtilityById = async (id, query) => {
  try {
    const url = `${apiUrl}/commission/utilitycommission/${id}${
      query ? `?searchText=${query}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const addUtility = async (value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/commission/utility-commission`,
      value
    );
    console.log(data);
    return data;
  } catch (error) {
    console.log(error);
  }
};
export {
  addService,
  getServiceForUpdate,
  editService,
  getService,
  addDmrService,
  getCommById,
  getUtilityById,
  addUtility,
};
